import React from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, BarChart3, UserCheck } from 'lucide-react';

export const AdminStatsPanel = ({ stats, t }) => {
  const cards = [
    { label: t('total_profiles'), value: stats?.total_profiles || 0, icon: Users, color: '#3B82F6' },
    { label: t('total_accounts'), value: stats?.total_accounts || 0, icon: UserCheck, color: '#10B981' },
    { label: t('claimed_profiles'), value: stats?.claimed_profiles || 0, icon: Heart, color: '#D98A94' },
    { label: t('categories'), value: Object.keys(stats?.categories || {}).length, icon: BarChart3, color: '#C7867A' },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="admin-stats-panel">
      {cards.map((s, i) => (
        <motion.div key={s.label} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
          className="glass-card rounded-xl p-5" data-testid={`stat-card-${i}`}>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${s.color}15` }}>
              <s.icon className="w-4 h-4" style={{ color: s.color }} />
            </div>
            <span className="t-text-muted text-xs uppercase tracking-wider">{s.label}</span>
          </div>
          <p className="text-3xl font-bold t-text">{s.value}</p>
        </motion.div>
      ))}
    </div>
  );
};
